module.exports = __webpack_public_path__ + "static/media/dashboard_img.a2263b8a.svg";